// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__17buF","head":"ProcedureTableInfo_head__3ef7o"};